import { Component, Input } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'mg-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
  standalone: false
})
export class PageTitleComponent {
  @Input() withBorder = false
  @Input() title: string
  @Input() titleClass = ''
  @Input() subTitle?: string
  @Input() showTaxInfoTooltip = false
  @Input() taxInfoTooltipExtraClass = ''
  @Input() extraClass = ''

  taxInfoTooltipDescription = 'Sales numbers shown in this page don’t include taxes.'
}
